<template>
  <div>
    <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <div class="pt-3">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10">
              <div class="row headercontenido">
                <div class="col-6 col-md-6">
                  <span class="titulo sub">
                    <router-link to="/egresados/estatus">Egresados</router-link>
                    <i class="fa fa-chevron-right"></i> Actualiza tus Datos
                  </span>
                </div>
                <div class="col-6 col-md-6"></div>
              </div>

              <div class="contenido">
                <div class="row">
                  <div class="col-12 col-lg-8 offset-lg-2 pb-3">
                    <div class="formulario col-12 bggris rounded pt-5 pb-4 card">
                      <h2 class="text-center mb-3 pb-2">Actualiza tus datos</h2>
                      <form
                        method="post"
                        @submit="submitFormulario($event)"
                        
                      >
                        <label>
                          <span>Título (Grado Académico):</span>
                          <input
                            type="text"
                            v-model="form.titulo"
                            placeholder="Título (Grado Académico)"
                          />
                        </label>
                        <label>
                          <span>*Nombre(s):</span>
                          <input
                            required
                            type="text"
                            v-model="form.nombre"
                            placeholder="Nombre(s)"
                          />
                        </label>
                        <label>
                          <span>*Apellido Paterno:</span>
                          <input
                            required
                            type="text"
                            v-model="form.apellido_paterno"
                            placeholder="Apellido Paterno"
                          />
                        </label>
                        <label>
                          <span>*Apellido Materno:</span>
                          <input
                            required
                            type="text"
                            v-model="form.apellido_materno"
                            placeholder="Apellido Materno"
                          />
                        </label>
                        <label>
                          <span>Nombre de la compañía en la que labora:</span>
                          <input
                            type="text"
                            v-model="form.empresa"
                            placeholder="Nombre de la compañía en la que labora"
                          />
                        </label>
                        <label>
                          <span>Departamento:</span>
                          <input
                            type="text"
                            v-model="form.departamento"
                            placeholder="Departamento"
                          />
                        </label>
                        <label>
                          <span>Puesto:</span>
                          <input type="text" v-model="form.puesto" placeholder="Puesto" />
                        </label>
                        <label>
                          <span>Nivel de estudios actual:</span>
                          <input
                            type="text"
                            v-model="form.estudios"
                            placeholder="Nivel de estudios actual"
                          />
                        </label>
                        <label>
                          <span>*Teléfono:</span>
                          <input
                            required
                            type="text"
                            v-model="form.telefono"
                            placeholder="Teléfono"
                          />
                        </label>
                        <label>
                          <span>*Teléfono Móvil:</span>
                          <input
                            required
                            type="text"
                            v-model="form.celular"
                            placeholder="Teléfono Móvil"
                          />
                        </label>
                        <label>
                          <span>*Correo electrónico:</span>
                          <input
                            required
                            type="text"
                            v-model="form.user_email"
                            placeholder="Correo electrónico"
                          />
                        </label>

                        <label>
                          <span>Sitio Web:</span>
                          <input type="text" v-model="form.sitio_web" placeholder="Sitio Web" />
                        </label>

                        <label class="py-3">
                          <input type="checkbox" required /> Acepto los términos y condiciones del <a href="https://www.iee.edu.mx/aviso-de-privacidad" target="_blank" >Aviso de Privacidad</a>.
                        </label>

                        <div class="text-center pt-2">
                          <button type="submit" class="submit btnblanco">Actualizar datos</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <span class="loading" v-bind:class="{active: this.$store.state.loading}">
                  <img src="../../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style>
@import "//netdna.bootstrapcdn.com/bootstrap/3.0.0/css/bootstrap-glyphicons.css";
</style>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../../Components/Header.vue";
import Menu from "../../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "IEEServiciosAcademicos",
  props: {
    msg: String
  },
  data() {
    return {
      form: {
        id:"",
        nombre: "",
        apellido_paterno: "",
        apelligo_materno: "",
        user_email: "",
        titulo: "",
        empresa: "",
        departamento: "",
        puesto: "",
        estudios: "",
        telefono: "",
        celular: "",
        sitio_web: ""
      },
      tiposervicio: "",
      columns: [
        "matricula",
        "nombre",
        "user_email",
        "grupos",
        "uri",
        "baja",

        "banned"
      ],
      datos: null,
      data: null,
      mensaje: "",
      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          matricula: "Matrícula",
          nombre: "Nombre",
          user_email: "Email",
          grupos: "Grupos",
          uri: "Actualización de datos",
          baja: "Baja",
          banned: "Bloqueo"
        },
        editableColumns: ["name"],
        sortable: ["matricula", "nombre", "user_email", "grupos"],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed"
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Búsqueda",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas"
        }
      }
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu
  },
  mounted: function() {
    this.$store.state.user = JSON.parse(this.$cookie.get("useriee"));
    AOS.init();
    this.consulta();
  },
  methods: {
    consulta() {
      console.log("consulta");

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_plantel: this.$store.state.user.id_plantel,
        user: this.$store.state.user
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "egresados/consulta-actualizacion.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");

              this.form.id = res.datos.id;
              this.form.nombre = res.datos.nombre;
              this.form.apellido_paterno = res.datos.apellido_paterno;
              this.form.apellido_materno = res.datos.apellido_materno;
              this.form.user_email = res.datos.user_email;
              this.form.titulo = res.datos.titulo;
              this.form.empresa = res.datos.empresa;
              this.form.departamento = res.datos.departamento;
              this.form.puesto = res.datos.puesto;
              this.form.estudios = res.datos.estudios;
              this.form.telefono = res.datos.telefono;
              this.form.celular = res.datos.celular;
              this.form.sitio_web = res.datos.sitio_web;

              console.log(this.form);
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    submitFormulario(e) {
      console.log("consulta");
      e.preventDefault();
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_plantel: this.$store.state.user.id_plantel,
        user: this.$store.state.user,
        form: this.form
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "egresados/actualizacion-datos.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              swal.fire("Bien", res.msg, "success");
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    }
  }
};
</script>

